<template>
  <header class="embed-header">
    <a
      v-if="url"
      :href="url"
      target="_blank"
      rel="noopener"
      class="embed-header__title"
      :title="title"
    >{{ title }}</a>
    <span v-else class="embed-header__title" :title="title">{{ title }}</span>
    <div class="embed-header__actions">
      <slot></slot>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// The stacked layout's title bar: the hike or recording name on the left, and
// the controls that would otherwise float over the map (routes, View on
// HiiKER) on the right.
export default defineComponent({
  name: 'EmbedHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  }
});
</script>

<style scoped>
.embed-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 6px 8px 6px 12px;
  background: #282a32;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
  position: relative;
  z-index: 150;
}

.embed-header__title {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

a.embed-header__title:hover {
  text-decoration: underline;
}

.embed-header__actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 400px) {
  .embed-header__title {
    font-size: 13px;
  }
}
</style>
